import React from 'react';
import PropTypes from 'prop-types';
import { Form, Checkbox } from 'semantic-ui-react';
import { getAccountGroupOptions, formTostate } from 'entities/Account';
import BalanceTable from './BalanceTable';
import './index.css';
import { withTranslation } from 'react-i18next';
import { trackClick } from 'util/firebaseAnalytics';

class AccountForm extends React.Component {
  constructor(props) {
    super(props);

    this.groups = getAccountGroupOptions();
  }

  handleNameChange = (event, { value }) => this.props.changeName(value);
  handleGroupChange = (event, { value }) => this.props.changeGroup(value);

  handleSubmit = event => {
    trackClick('Save Account');
    event.preventDefault();
    this.props.saveAccount(formTostate(this.props.form));
  };

  render() {
    const { t } = this.props;

    return (
      <Form className="account-form" onSubmit={this.handleSubmit}>
        <Form.Group>
          <Form.Input
            width={9}
            required
            label={t('accounts.label_name')}
            placeholder={t('accounts.input_placeholder')}
            value={this.props.form.name}
            onChange={this.handleNameChange}
          />
          <Form.Select
            width={7}
            label={t('accounts.input_group')}
            value={this.props.form.group}
            options={_.map(this.groups, (g) => ({...g, text: t(`accounts.groups.${g.text}`)}))}
            onChange={this.handleGroupChange}
          />
        </Form.Group>
        <BalanceTable {...this.props} />
        <Form.Group unstackable className="last-field">
          <Form.Field width={9} style={{ paddingTop: '0.5em' }}>
            <Checkbox
              label={t('accounts.checkbox_input')}
              checked={this.props.form.on_dashboard}
              onChange={this.props.toggleOnDashboard}
            />
          </Form.Field>
          <Form.Button width={7} primary fluid content={t('accounts.btn_save_account')} />
        </Form.Group>
      </Form>
    );
  }
}

AccountForm.propTypes = {
  form: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    group: PropTypes.string,
    balance: PropTypes.objectOf(PropTypes.string),
    currencies: PropTypes.arrayOf(PropTypes.string),
    on_dashboard: PropTypes.bool
  }),
  base: PropTypes.string.isRequired,
  secondary: PropTypes.arrayOf(PropTypes.string),
  changeName: PropTypes.func,
  changeGroup: PropTypes.func,
  toggleOnDashboard: PropTypes.func,
  toggleCurrency: PropTypes.func.isRequired,
  changeBalance: PropTypes.func.isRequired,
  saveAccount: PropTypes.func
};

export default withTranslation() (AccountForm);
